import { useEffect } from 'react';

// On phones, CSS (index.css .rt) stacks table rows as cards; this labels each cell with its column header.
const labelTables = () => {
  document.querySelectorAll('table:not(.no-rt)').forEach((table) => {
    const cellsOf = (el) => [...el.children].flatMap((c) => (c.tagName === 'TD' || c.tagName === 'TH' ? [c] : cellsOf(c)));
    const heads = [...table.querySelectorAll('thead th')].map((th) => th.textContent.trim());
    if (heads.length < 3) return;
    table.classList.add('rt');
    table.querySelectorAll('tbody tr, tfoot tr').forEach((tr) => {
      let col = 0;
      cellsOf(tr).forEach((td) => {
        const label = heads[col] || '';
        if (td.getAttribute('data-label') !== label) td.setAttribute('data-label', label);
        col += td.colSpan || 1;
      });
    });
  });
};

export const useResponsiveTables = () => {
  useEffect(() => {
    let raf = 0;
    const run = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(labelTables); };
    const obs = new MutationObserver(run);
    obs.observe(document.body, { childList: true, subtree: true });
    run();
    return () => { obs.disconnect(); cancelAnimationFrame(raf); };
  }, []);
};
